import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import EditableTextField from '@/components/Lead/EditableTextField';
import { F } from '@/utils/intl';
import styles from './index.less';

const OrderVolume = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  const customer = lead.customer || null
  return <EditableTextField isCustomer  isTable={isTable} lead={lead} property={'customer.order_volume'}>
    {customer?.order_volume || (
      <span className={styles.orderVolumePlaceholder}>
        <F id={'pages.lead.fields.order_volume'} defaultMessage={'Order Volume'} />
      </span>
    )}
  </EditableTextField>
}

export default OrderVolume
